module.exports = __webpack_public_path__ + "static/media/Daredevil.22c74084.jpg";